import { render } from "./DeliveryZones.vue?vue&type=template&id=7d9eab11&scoped=true"
import script from "./DeliveryZones.vue?vue&type=script&lang=js"
export * from "./DeliveryZones.vue?vue&type=script&lang=js"

import "./DeliveryZones.vue?vue&type=style&index=0&id=7d9eab11&scoped=true&lang=css"
import "./DeliveryZones.vue?vue&type=style&index=1&id=7d9eab11&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9eab11"]])

export default __exports__